// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__3ME_M","info":"UpdateTermsInfo_info__3pZbA"};